













import Vue from 'vue';
import RiskBox from 'common/components/ui/RiskBox/index.vue';
import customerClient from '../../../apis';

export default Vue.extend({
  components: {
    RiskBox,
  },
  props: {
    customer: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    remark: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showDeleteBox: false,
    };
  },
  methods: {
    deleteConfirm() {
      const remarks = JSON.parse(JSON.stringify(this.$props.customer.remarks));
      remarks.splice(this.$props.index, 1);
      customerClient.setRemarks({
        openid: this.$props.customer.openid,
        remarks,
      }).success((r) => {
        this.$Message.success('删除标签成功');
        this.$store.commit('SET_CUSTOMER_REMAKRS', remarks);
        this.showDeleteBox = false;
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
  },
});
